// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ColumnCarousel_carousel__PJzC0","pagination":"ColumnCarousel_pagination___SMv9"};